export const VALIDATION_SERIAL_NUMBER: RegExp = /\b[0-9a-zA-z]{12}\b/;

export const VALIDATION_IP_ADDRESS: RegExp =
  /\b[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\b/;

// eslint-disable-next-line no-useless-escape
export const TYPE_TIMEZONE = /\([A-Z]{0,}[+-]{1}[0-9]{2}\:[0-9]{2}\)/gm;
